export class AuthenticationResult {
    constructor(public readonly success: boolean, public readonly cryptId: string) {}
}
